import { serializeQuery } from '../Components/ReportCharts/ReportDataTransform';
import { BASE_PATH } from '../__mocks__/api';

export interface LoginApiRequest {
  username: string;
  password: string;
}

export const doLogin = async (requestObj: LoginApiRequest) => {
  let fetchUrl = BASE_PATH + '/login';

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: serializeQuery(requestObj),
  };

  const result = await fetch(fetchUrl, requestOptions);
  return result;
};

export const doGetCustomerInfo = async () => {
  let fetchUrl = BASE_PATH + '/reportdata';

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: serializeQuery( {'request': 'getCustomerInfo'} ),
  };

  const result = await (await fetch(fetchUrl, requestOptions)).json();
  return result;
};
